export const ENA_VIEW_URL = 'https://www.ebi.ac.uk/ena/browser/view/';
export const IMG_URL =
  ' https://img.jgi.doe.gov/cgi-bin/m/main.cgi?section=TaxonDetail&page=taxonDetail&taxon_oid=';
export const NCBI_ASSEMBLY_URL = 'https://www.ncbi.nlm.nih.gov/assembly/';
export const NCBI_SAMPLE_URL = 'https://www.ncbi.nlm.nih.gov/biosample/?term=';
export const NCBI_PROJECT_URL = 'https://www.ncbi.nlm.nih.gov/bioproject/';
export const PATRIC_URL = 'https://www.patricbrc.org/view/Genome/';
